// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"AboutPictures_moduleWrapper__NoRRI","picture1":"AboutPictures_picture1__tEQrz","picture2":"AboutPictures_picture2__NZdVU","picture3":"AboutPictures_picture3__CyC0L"};